import {createStyles, Stack, Text} from '@mantine/core';
import React from 'react';

import SelectablePlateList, {SelectablePlate} from 'samples/plate-maps/scratch-plates/SelectablePlateList';
import {PlateSize} from 'samples/storables/StorableSchemaConstants';

interface SelectPlatesStepProps {
  plates: Array<SelectablePlate>;
  plateSize: PlateSize;
  selectedPlateIds: ReadonlySet<string>;
  onToggleSelected: (scratchPlateId: string) => void;
  onSelectAll: () => void;
  onDeselectAll: () => void;
}

export default function SelectPlatesStep({
  plates,
  plateSize,
  selectedPlateIds,
  onToggleSelected,
  onSelectAll,
  onDeselectAll,
}: SelectPlatesStepProps): JSX.Element {
  const {classes} = useStyles();

  return (
    <Stack spacing="sm">
      <Text className={classes.text}>Select plates to put into inventory.</Text>
      <SelectablePlateList
        plates={plates}
        plateSize={plateSize}
        selectedPlateIds={selectedPlateIds}
        onToggleSelected={onToggleSelected}
        onSelectAll={onSelectAll}
        onDeselectAll={onDeselectAll}
      />
    </Stack>
  );
}

const useStyles = createStyles((theme) => ({
  text: {
    fontSize: theme.fontSizes.md,
  },
}));
